import { debounce, findIndex, isEmpty } from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import moment from 'moment';

import DatePickerButton from '../../components/DatePickerButton';
import { dayShape } from '../../shapes';
import config from '../../../config';
import Icon, { GLYPHS } from '../../components/Icon';

const ITEMS_PER_SLIDE = 7;

const sliderControls = [{
  // eslint-disable-next-line react/prop-types
  component: ({ previousSlide, currentSlide }) => (
    <button
      className="c-date-slider__prev"
      onClick={previousSlide}
      disabled={currentSlide === 0}
    >
      <Icon glyph={GLYPHS.PREV_WEEK} className="c-date-slider__arrow-icon" />
    </button>
  ),
  style: {
    position: 'static',
    order: -1,
  },
}, {
  // eslint-disable-next-line react/prop-types
  component: ({ nextSlide, currentSlide, slideCount, slidesToScroll }) => (
    <button
      className="c-date-slider__next"
      onClick={nextSlide}
      disabled={currentSlide + slidesToScroll >= slideCount}
    >
      <Icon glyph={GLYPHS.NEXT_WEEK} className="c-date-slider__arrow-icon" />
    </button>
  ),
  style: {
    position: 'static',
    order: -1,
  },
}];

const sliderSettings = {
  className: 'c-date-slider',
  dragging: true,
  speed: 500,
  slidesToShow: ITEMS_PER_SLIDE,
  slidesToScroll: ITEMS_PER_SLIDE,
  cellAlign: 'left',
  cellSpacing: 0,
  decorators: sliderControls,
};

class DateSlider extends Component {
  componentWillReceiveProps(nextProps) {
    const newIndex = ITEMS_PER_SLIDE * Math.floor(findIndex(nextProps.days, 'active') / ITEMS_PER_SLIDE);
    this.index = newIndex;
  }

  shouldComponentUpdate(nextProps) {
    return this.props.updatedAt !== nextProps.updatedAt || this.props.activeDay !== nextProps.activeDay;
  }

  onAfterSlide = (nextIndex) => {
    const nextDay = moment().add(nextIndex, 'days').format(config.apiDateFormat);
    this.index = nextIndex;
    this.props.setActiveDay(nextDay);
  }

  onMouseDown = (e) => {
    this.mouseDown = true;
    this.mouseX = e.clientX;
    this.sliding = false;
  }

  onMouseUp = () => {
    this.mouseDown = false;
  }

  onMouseMove = debounce((e) => {
    if (!this.mouseDown) return;
    if (Math.abs(e.clientX - this.mouseX) > this.delta) {
      this.sliding = true;
      return;
    }

    this.sliding = false;
  }, 200)

  onClickCapture = (e) => {
    if (this.sliding) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  onDatePickerDayClick = (day) => {
    this.props.setActiveDay(moment(day).format(config.apiDateFormat));
  }

  getDisabledDays() {
    const today = new Date();
    const endDay = moment(today).add(this.props.advanceBookDays - 1, 'days').toDate();

    return {
      before: today,
      after: endDay,
    };
  }

  sliding = false;
  mouseDown = false;
  mouseX = 0;
  delta = 2;
  index = 0;

  renderSlides() {
    if (isEmpty(this.props.days)) return null;

    return this.props.days.map((day) => {
      const className = classnames(
        'c-date-slider__item',
        { 'is-active': day.active },
        { 'is-disabled': day.disabled }
      );
      return (
        <button
          className={className}
          onClick={this.props.onDayClick(day.date)}
          key={day.date}
        >
          <div className="c-heading c-heading--tiny u-co-gray-1">
            {day.dayOfWeek}
          </div>
          <div className="c-date-slider__item-day">
            {day.formatted}
          </div>
        </button>
      );
    });
  }

  render() {
    return (
      <div
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onMouseMove={(e) => {
          e.persist();
          this.onMouseMove(e);
        }}
        onClickCapture={this.onClickCapture}
        role="presentation"
      >
        <div className="c-date-slider__date">
          <div className="layout layout--tiny layout--auto">
            <div className="layout__item">
              {moment(this.props.activeDay).format('ddd, MMM D, YYYY')}
            </div>
            <div className="layout__item">
              <div className="c-date-slider__date-picker">
                <DatePickerButton
                  onDayClick={this.onDatePickerDayClick}
                  selectedDay={moment(this.props.activeDay).toDate()}
                  disabledDays={this.getDisabledDays()}
                  daysOff={this.props.daysOff}
                  daysOn={this.props.daysOn}
                  weekdaysOff={this.props.weekdaysOff}
                />
              </div>
            </div>
          </div>
        </div>
        <Carousel
          afterSlide={this.onAfterSlide}
          slideIndex={this.index}
          {...sliderSettings}
        >
          {this.renderSlides()}
        </Carousel>
      </div>
    );
  }
}
DateSlider.propTypes = {
  days: PropTypes.arrayOf(dayShape).isRequired,
  activeDay: PropTypes.string.isRequired,
  setActiveDay: PropTypes.func.isRequired,
  onDayClick: PropTypes.func.isRequired,
  updatedAt: PropTypes.number,
  advanceBookDays: PropTypes.number,
  daysOff: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  daysOn: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  weekdaysOff: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};

DateSlider.defaultProps = {
  updatedAt: 0,
  advanceBookDays: 0,
};

export default DateSlider;



// WEBPACK FOOTER //
// ./src/app/times/components/DateSlider.jsx